import { loadHbridge } from './globalLoader';

const pkg = require('../../package.json');

export const getVersion = async () => {
  const { env, Native } = await loadHbridge();
  let { version } = pkg;
  if (env.isEasyBikeApp) {
    // 哈啰出行 APP
    version = env.appVersion;
  } else if (env.isAliMPMonitor || env.isAliMP) {
    try {
      version = await Native.callNative({
        method: 'getVersion',
        classMap: 'SwitchBridge',
      });
    } catch (e) {
      // empty
    }
  }
  return version;
};

/**
 * 版本号对比
 * @param {*} ver1 版本1
 * @param {*} ver2 版本2
 * @return {Number} -1: 版本1 < 版本2;  1: 版本1 > 版本2;  0: 版本1 = 版本2
 */
export function versionCompare(ver1, ver2) {
  const v1 = ver1 || '0.0.0';
  const v2 = ver2 || '0.0.0';
  if (v1 === v2) {
    return 0;
  }
  const v1Arr = v1.split('.');
  const v2Arr = v2.split('.');
  const len = Math.max(v1.length, v2.length);
  for (let i = 0; i < len; i += 1) {
    const v1Item = Math.floor(v1Arr[i]);
    const v2Item = Math.floor(v2Arr[i]);
    if (v1Item < v2Item) {
      return -1;
    } if (v1Item > v2Item) {
      return 1;
    }
  }
  return 0;
}
